module.exports = __webpack_public_path__ + "static/media/diktat-12.ef454af4.mp3";